import React from "react";
import Link from "../Link/Link";

interface IProps {
    overrideText?: string;
    goBackUrl?: string;
    fallbackUrl?: string; // Optional fallback if there's no referrer/history
    handleGoBackOverride?: () => void;
}

const GoBackLink: React.FC<IProps> = ({
    overrideText,
    goBackUrl,
    fallbackUrl = "/",
    handleGoBackOverride
}) => {
    const handleGoBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (goBackUrl) {
            // Explicit URL provided
            window.location.href = goBackUrl;
        } else if (window.history.length > 1) {
            // Browser has history
            window.history.back();
        } else {
            // Fallback
            window.location.href = fallbackUrl;
        }
    };

    return (
        <Link icon="angleLeft" onClick={handleGoBackOverride || handleGoBack}>
            {overrideText || "Fara til baka"}
        </Link>
    );
};

export default GoBackLink;
